<template>
  <ul class="carousel-nav max-w-sm pr-8">
    <li
      v-for="(item, index) in navItems"
      :key="`nav-item-${index}`"
      class="relative cursor-pointer flex items-center"
      :class="{ 'text-primary': index === current }"
      style="width: 345px"
      @click="$emit('set-nav', index)"
    >
      <div
        class="active-indicator absolute left-0 top-2/4 -translate-y-1/2 w-1 h-6 rounded"
        :class="index === current ? 'bg-primary' : 'bg-transparent'"
      ></div>
      <TypeHeading
        :variant="$options.Typography.Heading.HEADLINE"
        :weight="
          index === current
            ? $options.Typography.Weights.STRONG
            : $options.Typography.Weights.REGULAR
        "
        tag="p"
        class="leading-6 pl-8 py-4"
      >
        {{ item }}
      </TypeHeading>
    </li>
  </ul>
</template>

<script>
import { TypeHeading, constants } from '@bambeehr/pollen';
import { defineComponent } from '@vue/composition-api';
const { Typography } = constants;

export default defineComponent({
  name: 'CarouselNavigation',
  Typography,
  components: { TypeHeading },
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
  },
  setup() {},
});
</script>

<style scoped>
@media screen and (max-width: 1199px) {
  .carousel-nav {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .carousel-nav {
    display: block;
  }
}
</style>
